import { render, staticRenderFns } from "./myorder.vue?vue&type=template&id=f611c51e&scoped=true&"
import script from "./myorder.vue?vue&type=script&lang=js&"
export * from "./myorder.vue?vue&type=script&lang=js&"
import style0 from "./myorder.vue?vue&type=style&index=0&id=f611c51e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f611c51e",
  null
  
)

export default component.exports